<template>
  <div class="animated fadeIn">
    <b-card border-variant="primary">
      <template slot="header">
        <i class='fa fa-align-justify'></i> Server List
      </template>
      <!-- detail search start -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_date"> Installed_at
                <b-button size="sm" variant="info" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="opt_visit"> last config updated_at
                <b-button size="sm" variant="info" @click="set_sd('', 'updated_at')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'updated_at')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'updated_at')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'updated_at')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'updated_at')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'updated_at')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.updated_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.updated_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <b-form-group>
              <label for="opt_mod">Mode</label>
              <br>
              <select v-model="so.opt['mode']" @change="refresh">
                <option disabled value="">Please select Mode</option>
                <option value="0">Off</option>
                <option value="1">DetectionOnly</option>
                <option value="2">Block</option>
              </select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label for="opt_level">Level</label>
              <br>
              <select v-model="so.opt['level']" @change="refresh">
                  <option disabled value="">select Enable or Disable</option>
                  <option value="1">Level : 1</option>
                  <option value="2">Level : 2</option>
                  <option value="3">Level : 3</option>
                  <option value="4">Level : 4</option>
                </select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label for="opt_version">Version</label>
              <br>
              <select v-model="so.opt['version']" @change="refresh">
                <option disabled value="">Please select Version</option>
                <option value="v1">Version : 1</option>
                <option value="v2">Version : 2</option>
              </select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group>
              <label for="opt_ip_addr">IP Address</label>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_ip_addr" v-model="so.opt['ip_addr']"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group>
              <label for="opt_nickname_module">Nickname</label>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_nickname_module" v-model="so.opt['nickname']"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <label for="ph_search_opt_type">Match Type</label>
            <b-form-group>
              <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
                <b-form-radio value="and">[AND]:Match all</b-form-radio>
                <b-form-radio value="or">[OR]:Match at least one</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <label for="ph_search_opt_type">Group Name</label>
            <b-button variant="primary" @click="chainGroup = true">Select Group</b-button>
            <b-form-group>
              <b-form-input @keydown.enter="refresh" type="text" :disabled="false" v-model="group_name">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group class="float-right">
          <b-button size="sm" variant="success" @click="refresh"> Search </b-button>
          <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
        </b-form-group>
      </b-card>
      <!-- detail search end -->

      <hr>
      <b-row>
        <b-col sm="2">
          <b-badge variant="primary">
            TOTAL : {{summaryData.enable + summaryData.disable}}
          </b-badge>
          <br>
          <b-badge variant="success">
            USE : {{summaryData.enable}}
          </b-badge>
          <br>
          <b-badge variant="warning">
            Deleted : {{summaryData.disable}}
          </b-badge>
        </b-col>
        <b-col sm="10" class="md-12">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :text="so.skt || 'Search'" size="sm" variant="outline-secondary" :disabled="so.adv">
                <!-- <b-dropdown-item size="sm" @click="so.sk='permissions';so.skt='Permission'; so.sv = 'Owner'">Permission</b-dropdown-item> -->
                <b-dropdown-item size="sm" @click="so.sk='version';so.skt='Version'; so.sv = ''">Version</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='mode';so.skt='Mode'; so.sv = ''">Mode</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='level';so.skt='Level'; so.sv = ''">Level</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='nickname';so.skt='Nickname'; so.sv = ''">Nickname</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='ip_addr';so.skt='IP'; so.sv = ''">IP</b-dropdown-item>
              </b-dropdown>

              <select :disabled="so.adv" v-model="so.sv" v-if="so.sk == 'mode'" @change="$refs._list.refresh()">
                <option disabled value="">Please select Allow or Not Allow</option>
                <option value="0">Off</option>
                <option value="1">DetectionOnly</option>
                <option value="2">Block</option>
              </select>
              <select :disabled="so.adv" v-model="so.sv" v-if="so.sk == 'version'" @change="$refs._list.refresh()">
                <option disabled value="">Please select version</option>
                <option value="v1">V1</option>
                <option value="v2">V2</option>
              </select>
              <select :disabled="so.adv" v-model="so.sv" v-if="so.sk == 'level'" @change="$refs._list.refresh()">
                <option disabled value="">Please select level</option>
                <option value="1">LEVEL : 1</option>
                <option value="2">LEVEL : 2</option>
                <option value="3">LEVEL : 3</option>
                <option value="4">LEVEL : 4</option>
              </select>
            </b-input-group-prepend>
            <b-form-input :disabled="so.adv" v-if="['level', 'version', 'mode'].indexOf(so.sk) == -1" v-model="so.sv" @keyup.enter="refresh()"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="search_opt"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
          <br>
          <b-input-group size="sm">
            <select v-model="so.perPage" @change="refresh" style="margin-right:15px">
                <option disabled value="15">Show count : Default 15</option>
                <option value=10>10</option>
                <option value=50>50</option>
                <option value=100>100</option>
              </select>

              <select v-if="sync.enable" v-model="sync.interval" @change="refresh" style="margin-right:15px">
                <option disabled value="15">Please select interval : Default 15</option>
                <option value=10>10</option>
                <option value=30>30</option>
                <option value=60>60</option>
                <option value=300>300(5 min)</option>
              </select>
              <span v-if="sync.enable" class="float-right" style="margin-right:15px">
                <i :class="`fa fa-refresh ${sync.th && sync.stop ? 'fa-spin' : ''}`" style="margin-right:5px"></i>
                <b-btn @click="pause" size="sm" variant="warning">
                  {{!sync.stop ? "Auto refresh"  : "Pause"}}
                </b-btn>
              </span>
              <!-- <div>
                <b-button size="sm" v-if="enable_new !== false" variant="success" @click="add"> New Registration </b-button>
              </div> -->
          </b-input-group>
        </b-col>
      </b-row>
      <hr>

      <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found"
        :items="load" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="created_at" slot-scope="row">{{row.item.created_at | datetime}}</template>
        <template slot="group.groupname" slot-scope="row">
          <span @click="detail(row.item)" class="font-weight-bold">
            {{row.item.group && row.item.group.groupname || 'deleted group'}}
          </span>
        </template>
        <template slot="version" slot-scope="row">{{row.item.version}}</template>
        <template slot="nickname" slot-scope="row">
          <del style="cursor: pointer;" v-if="row.item.group.is_del" @click="detail(row.item)" class="font-weight-bold">{{row.item.nickname}}</del>
          <template v-else>
            <span @click="detail(row.item)" class="font-weight-bold" style="cursor: pointer;">
              {{row.item.nickname}}
            </span>

          </template>
        </template>
        <template slot="mode" slot-scope="row">
          <b-badge v-if="row.item.mode == 0" variant="secondary">Off</b-badge>
          <b-badge v-if="row.item.mode == 1" variant="warning">DetectionOnly</b-badge>
          <b-badge v-if="row.item.mode == 2" variant="danger">Block</b-badge>
        </template>
        <template slot="level" slot-scope="row">
          <b-badge v-if="row.item.level == 1" variant="default">{{row.item.level}}</b-badge>
          <b-badge v-if="row.item.level == 2" variant="secondary">{{row.item.level}}</b-badge>
          <b-badge v-if="row.item.level == 3" variant="warning">{{row.item.level}}</b-badge>
          <b-badge v-if="row.item.level == 4" variant="danger">{{row.item.level}}</b-badge>
        </template>
        <!-- <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">More</b-btn>
        </template> -->
      </b-table>
      <hr>
      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" prev-text="Prev" next-text="Next"  />
        </b-col>
        <!-- <b-col class="md-4">
          <div class="pull-right">
            <b-button size="sm" variant="success" @click="$router.push({ name: 'user', params: { id : 'add' } })"> New Registration </b-button>
          </div>
        </b-col> -->
      </b-row>
    </b-card>
    <!-- start connect group modal -->
    <b-modal title="Find then Group and Select" size="xl"  header-bg-variant="info" v-model="chainGroup" @ok="chainGroup = false" ok-variant="info">
      <group-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setGroup"></group-List>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import custom from '@/custom';
import { Api } from '@/service';
import codes from '@/codes';
import vSelect from 'vue-select';
import groupList from '../../Management/group/Group.List'

const default_opt = () => ({
  perPage: 15,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv: false
});
// props explain
// auto_refresh : auth sync enable or disable, value is boolean
// group : this component to group list, using by group dependency

export default {
  name : "userList",
  props: ['group', "auto_refresh", "view_detail", "enable_new", "delay"],
  watch: {
    group() {
      console.log("watch updated props data", this.group.groupname)
      this.load()
    }
  },
  components: { DatePicker, vSelect, groupList },
  data: () => ({
    group_name : "",
    chainGroup : false,
    codes,
    custom,
    so : default_opt(),
    sync : { th : undefined, stop : false, interval : 15, enable : false },
    summaryData : { enable : 0, disable : 0 },
    model : {}
  }),
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      let f = [
        { key: 'id', thStyle: 'width: 5%', label: 'No.' },
        { key: 'created_at', label : 'Installed', sortable: true, thStyle : 'width: 10%' },
        { key: 'group.groupname', label : 'Group', sortable: true },
        { key: 'nickname', label: 'Nickname', sortable: true },
        { key: 'version', label: 'Version', sortable: true },
        { key: 'mode', label: 'Mode', sortable: true },
        { key: 'level', label: 'Level', sortable: true, thStyle : 'width: 10%' },
        { key: 'ip_addr', label: 'IP', sortable: false, thStyle : 'width: 10%' },
        // { key: 'func', label: 'Action', sortable: false, thStyle: 'width: 10%'  },
      ]
      if(this.group && this.group.id) { f.splice(1, 1); } // remove username
      return f;
    }
  },
  methods: {
    setGroup(item) {
      console.log("group info", item.groupname, item.id)
      this.so.opt['group_id'] = item.id
      this.group_name = item.groupname;
      this.chainGroup = false;
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['match_type'] = 'and';

        this.so.sv = '';
      } else { this.reset(); }
    },
    set_op(k, v) {
      if(['level', 'mode', 'group_id'].indexOf(k) > -1) {
        // console.log({ name : k, value : parseInt(v, 10), op : '=' })
        return { name : k, value : parseInt(v, 10), op : '=' };
      } else if(v == 'false' || v == 'true') {
        return { name : k, value : v === "false" ? false : true, op : '=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    summary() {
      let and = [];
      if(this.group) { and.push({ name : 'group_id', value : this.group.id, op : '='}) }
      Api.Manager_Call('webcastle.agent','summary', { and : and, or : [], sort : [] })
        .then(rs => { this.summaryData = Object.assign(this.summaryData, { enable : rs.body.enable, disable : rs.body.disable }) })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    reset() { this.so = default_opt(); this.group_name = ''; this.refresh(); },
    refresh() {
      console.log("refresh", this.$route.name, new Date());
      if(this.$refs._list) {
        this.$refs._list.refresh();
        if(this.sync.enable) {
          this.sync.stop = false; this.pause();
        }
      }
    },
    pause: function() {
      this.sync.stop = !this.sync.stop;
      if(this.sync.th) { clearTimeout(this.sync.th); this.sync.th = undefined; }
      if(!this.sync.th && this.sync.stop) { this.sync.th = setTimeout(this.refresh, 1000 * this.sync.interval ); }
    },
    add() {
      if(this.view_detail !== false) {
        this.$router.push({ name: 'webcastle.agent', params: { id : 'add' } })
      } else {
        this.$router.push({ name: 'webcastle.agent', params: { id : this.$route.params.id, tag : "group" } })
      }
    },
    getRowCount () { return this.so.totalRows || 0; },
    load(ctx = {}) {
      let so = {
        target : 'webcastle.agent', cmd : 'list',
        body : {
          sort : [{ name : "id", op : "desc" }],
          or : [],
          and : []
        },
        offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
      }

      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.group) { so.body.and.push({ name : 'group_id', value : this.group.id, op : '='}) }
      if(this.so.sk && (this.so.sv || '').trim()) { so.body.and.push(this.set_op(this.so.sk, this.so.sv, so)); }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'level':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'version':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'mode':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            case 'updated_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'updated_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
      return Api.Manager(so).then(rs => { this.so.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText))
    },
    detail(item) {
      var str = item.version;
      var strArray = str.split('.')
      this.strArray = str.split('.')
      this.$router.push(`modules/${item.id}`);
    },
  },
  created() { console.log('WEBCastle_List.vue', 'created'); },
  destroyed() { console.log('WEBCastle_List.vue', 'destroyed'); },
  mounted() { console.log('WEBCastle_List.vue', 'mounted');
    if(this.auto_refresh == true) { this.sync.enable = this.auto_refresh; }
    if(!this.view_detail !== false) {
      // not component
      this.summary()
    }
  },
}
</script>
